import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const DeleteConfirmDialogBox = ({ open, handleClose, handleConfirm, isDeleting }) => {
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="delete-confirm-dialog-title"
            aria-describedby="delete-confirm-dialog-description"
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: { backgroundColor: theme.palette.background.paper },
            }}
        >
            <DialogTitle id="delete-confirm-dialog-title" variant="h2" fontWeight="bold">
                Confirm Delete
            </DialogTitle>
            <DialogContent>
                <Typography id="delete-confirm-dialog-description" sx={{ mt: 1 }}>
                    Are you sure you want to delete?
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button
                    onClick={handleClose}
                    variant="contained"
                    sx={{
                        color: theme.palette.text.black,
                        backgroundColor: theme.palette.text.white,
                        '&:hover': {
                            backgroundColor: theme.palette.text.white,
                        },
                        '&:focus': { outline: 'none' },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="error"
                    disabled={isDeleting}
                    sx={{
                        color: theme.palette.text.black,
                        '&:focus': { outline: 'none' },
                    }}
                >
                    {isDeleting ? 'Deleting...' : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteConfirmDialogBox;
